const chooseData = [
    {
        id: "1",
        title: "Comprehensive Listings",
        details: "We offer a wide range of properties to suit all needs and budgets"
    },
    {
        id: "2",
        title: "Expert Advice",
        details: "Our team of real estate professionals is always available to provide guidance and advice"
    },
    {
        id: "3",
        title: "User-Friendly Platform",
        details: "Our website is designed to be intuitive and easy to use"
    },
    {
        id: "4",
        title: "Excellent Customer Service",
        details: "Our customer service team is always available to assist you"
    },
    {
        id: "5",
        title: "Commitment to Innovation",
        details: "We are constantly updating and improving our platform to ensure that our users have access to the best tools and resources"
    },

]

export default chooseData;